import script from "./PagePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PagePanel.vue?vue&type=script&setup=true&lang=js"

import "./PagePanel.vue?vue&type=style&index=0&id=85303020&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85303020"]])

export default __exports__